enum FilterFieldsKeys {
  GroupSequence = "groupSequence",
  GroupName = "groupName",
  GroupType = "groupType",
  Status = "status",
  ChainName = "chainName",
  AssetName = "assetName",
  Actice = "active",
}

type FilterFields = {
  [FilterFieldsKeys.GroupSequence]: string;
  [FilterFieldsKeys.GroupName]: string;
  [FilterFieldsKeys.GroupType]: string;
  [FilterFieldsKeys.Status]: string;
  [FilterFieldsKeys.ChainName]: string;
  [FilterFieldsKeys.AssetName]: string;
  [FilterFieldsKeys.Actice]: string;
};

const initFields: FilterFields = {
  [FilterFieldsKeys.GroupSequence]: "",
  [FilterFieldsKeys.GroupName]: "",
  [FilterFieldsKeys.GroupType]: "",
  [FilterFieldsKeys.Status]: "",
  [FilterFieldsKeys.ChainName]: "",
  [FilterFieldsKeys.AssetName]: "",
  [FilterFieldsKeys.Actice]: "",
};

export { FilterFieldsKeys, type FilterFields, initFields };
